<script>

    export let icon = null
    export let text = ''
    export let tooltip = null
    export let type = 'button'
    export let color = 'light'
    export let size = ''
    export let iconType = 'fa'
    export let fullwidth = false
    export let loading = false
    /** ID del `<form>` asociado (útil si el botón no es descendiente del form en el DOM). */
    export let form = undefined

</script>

<button on:click type={type} {form} class="button is-{color} is-{size}" data-tooltip={tooltip} class:is-fullwidth={fullwidth} class:is-loading={loading}>
    {#if icon}
        <span class="icon"><i class="fas { iconType }-{ icon }"></i></span>
    {/if}
    {#if $$slots.default}
        <slot />
    {:else if text}
        <span>{ text }</span>
    {/if}
</button>
